export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-hairline bg-charcoal text-bone py-4" data-testid="brand-marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((t, i) => (
          <span key={i} className="mx-8 font-display text-xs tracking-luxe uppercase inline-flex items-center gap-8">
            {t} <span className="text-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
